import type { JSX } from 'react';

import { Waypoint } from 'react-waypoint';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useMarkModuleAsLoaded } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { CardCarousel } from './components/CardCarousel';
import { QRPosterCardVariant1 } from './components/QRPoster/components/QRPosterCard/variant1';
import { ReadyToSharePostsCardPreviewVariant1 } from './components/ReadyToSharePostsCard';
import { RecommendedGroupsCardPreview } from './components/RecommendedGroupsCard';
import { SocialContentPreviewLoadingVariant1 } from './components/SocialContent/components/SocialContentCard/variant1';
import { useSharingToolsTracking } from './hooks';
import { useSharingTools } from './hooks/useSharingTools';

export function Variant1(): JSX.Element {
	useMarkModuleAsLoaded('SharingTools', true);

	const { actions } = useSharingTools('petition_dashboard_grow_petition_v1');
	const { trackView } = useSharingToolsTracking('petition_dashboard_grow_petition_v1');

	const items = [
		{
			key: 'recommended-groups',
			component: <RecommendedGroupsCardPreview />,
		},
		{
			key: 'ready-to-share',
			component: <ReadyToSharePostsCardPreviewVariant1 />,
		},
		{
			key: 'social-content',
			component: <SocialContentPreviewLoadingVariant1 />,
		},
		{
			key: 'qr-poster',
			component: <QRPosterCardVariant1 />,
		},
	];
	return (
		<div className="w-full px-1 py-2 sm:my-8 md:m-0 md:px-12 md:py-12">
			<Waypoint onPositionChange={({ currentPosition }) => trackView(currentPosition)} />
			<div className="mb-4 flex flex-row items-center justify-between px-4 md:px-0">
				<Text variant="heading" size="small">
					<Translate value="corgi.petition.starter_dashboard_v2.sharing_tools.title" />
				</Text>
				<Button
					className="px-0 md:px-4"
					data-qa="all-tools-button"
					variant="tertiary"
					size="small"
					onClick={actions.navigateToAllTools}
				>
					<Translate value="corgi.petition.starter_dashboard_v2.sharing_tools.all_tools" />
				</Button>
			</div>

			<CardCarousel
				items={items}
				fullWidthItems={false}
				asLoop={false}
				trackingContext="petition_dashboard_grow_petition_v1"
			/>
		</div>
	);
}
